// frontend/src/services/authService.js
import axios from 'axios';

//const API_URL = 'http://localhost:5000/api/auth/'; // Your backend URL
const API_URL="https://sheettrackernode.sobalex.com/api/auth/";
const login = (username, password) => {
    return axios.post(API_URL + 'login', { username, password });
};

const getAccessiblePages = (token) => {
    return axios.get(API_URL + 'pages', {
        headers: { Authorization: `Bearer ${token}` }
    });
};

const getCurrentUser = () => {
    const token = localStorage.getItem('token');
    const userString = localStorage.getItem('user');
    if (token && userString) {
        try {
            const user = JSON.parse(userString);
            return { token, user };
        } catch (e) {
            console.error("Error parsing user from localStorage", e);
            // Optionally clear corrupted data
            // localStorage.removeItem('user');
            // localStorage.removeItem('token');
            return null;
        }
    }
    return null;
};

const logout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
};

// Assign the object to a variable before exporting
const authServiceObject = {
    login,
    logout,
    getCurrentUser,
    getAccessiblePages
};

export default authServiceObject; // Export the named variable as default
